module.exports = new __parcel__URL__("progress-simple--dark.eeee22e2.svg").toString();